// This file is automatically generated. Do not edit manually.

import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SirmetSitePartApi {
	export async function convertSitePartToConfigurable(args: { sitePartId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/sirmet/parts/sitePart/convertSitePartToConfigurable",
			method: "POST",
			data: {
				sitePartId: args.sitePartId,
			},
		});
		return response as void;
	}
}
